export default __webpack_public_path__ + "static/cookies-1c3386c30bf0fde95227313425eadf2a.svg";